/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

export const COMPANY_LEVEL_PROJECT_ID = 1;
const HOME_PAGE_ID = '-1000';

export class NavUrlHandler {

    constructor(menuItem, projectId) {
        this.menuItem = menuItem;
        this.projectId = projectId;
        this.menuItemUrl = '';
        this.historyName = '';
    }

    handle() {
        //Handle url and history name
        this.menuItemUrl = this.menuItem.url;
        this.historyName = '../tririga/#';
        let historyNameQueryStringPart = this.menuItem.name.length > 0 ? 'name=' + this.menuItem.name: '';
        this.historyName = this.historyName + historyNameQueryStringPart;
        //Add history hash if doesn't already exist here.
        this.menuItemUrl = this.handleHistoryHash(this.menuItemUrl);
        if (this.projectId && this.projectId > COMPANY_LEVEL_PROJECT_ID) {
            let projectContextUrl = this.handleProjectContextUrl();
            this.menuItemUrl = this.menuItemUrl + projectContextUrl;
            this.historyName = this.historyName + projectContextUrl;
        }
    }

    handleHistoryHash(menuItemUrl) {
      if (menuItemUrl.indexOf('#') < 0) {
        menuItemUrl = menuItemUrl + '#';
      }
      return menuItemUrl;
    }

    handleProjectContextUrl() {
        /* eslint eqeqeq: 0 */
        let projectQueryString = this.menuItem.id == HOME_PAGE_ID? 'project=': '&project=';
        return projectQueryString + this.projectId;
    }

    getMenuItemUrl() {
        return this.menuItemUrl;
    }

    getHistoryName() {
        return this.historyName;
    }

    getHashPart() {
        return this.historyName.replace('../tririga/', '');
    }

}